<template>
  <div class="home">
    <div class="photos" v-for="photo in photos" :key="photo.url">
      <Photo v-bind:url="photo.url"/>
    </div>

  </div>
</template>

<style>
  .photos {
    margin: 0px;
  }
</style>

<script>
// @ is an alias to /src
import Photo from '@/components/Photo.vue'

export default {
  name: 'home',
  components: {
    Photo
  },
  data() {
    return {
      photos: [
        { id: 1, url: "http://achia.co.uk/photos/photo_1725.jpg" },
        { id: 2, url: "http://achia.co.uk/photos/photo_3332.jpg" },
        { id: 3, url: "http://achia.co.uk/photos/photo_3385.jpg" },
        { id: 4, url: "http://achia.co.uk/photos/photo_5084.jpg" },
        { id: 5, url: "http://achia.co.uk/photos/photo_5468.jpg" }
      ]
    }
  }
}
</script>